export default function scrollToFormError() {

  // Important: When testing backend validation, reloading the page doesn't give reliable results because
  // the browser tries restoring the last scroll position which interferes with scrolling into view.
  // The current implementation is tested with hitting enter in the form or clicking "submit"
  const backendValidationErrors = document.querySelectorAll('.validation-errors-list.filled');
  if (backendValidationErrors.length) {
    let verticalOffsetOfFirstValidationError = backendValidationErrors[0].getBoundingClientRect().top;
    // Offset 250 chosen by trial and error
    window.scrollTo(0, verticalOffsetOfFirstValidationError - 250);
  }

}
